

















































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import { confirmOrderShipped, getOrderSummary, getOrderSummaryTimeline, postOrderComment } from '@/api/orders'
import { getProductSnapshot } from '@/api/products'
import * as Luxon from 'luxon'

interface ShipmentInfo {
  date_added: string
  date_modified: string
  order_id: number
  shipping_courier_id: number
  tracking_number: string
  data: ShippingStatus
}
interface ShippingEvent {
  description: string
  location: {
    address: {
      addressLocality: string
    }
  }
  statusCode: string
  timestamp: string
  status: string
}
interface ShippingStatus {
  id: string
  origin: any
  destination: any
  status: any
  details: any
  events: ShippingEvent[]
}
@Component({
  name: 'OrderSummary',
  components: {}
})
export default class extends Vue {
  invoiceNr = '220401-01'
  status = null
  customerName = null
  customerMail = null
  shipmentInfo: ShipmentInfo = null
  timeline = []
  commentInput = ''

  trackingCode = ''
  trackingCodeEnabled = true
  sendShippingNotification = true
  loadingConfirmShipping = false

  get shipmentStateCode() {
    return this.shipmentInfo.data.status.statusCode
  }
  get shipmentState() {
    console.log(this.shipmentInfo.data.events)
    return this.shipmentInfo.data.status.status
  }
  formattedEventTime(time: string) {
    const date = new Date(time)
    const lux = Luxon.DateTime.fromJSDate(date)
    return lux.setLocale('de').toLocaleString({
      weekday: 'short',
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    })
  }
  async orderShipped() {
    this.loadingConfirmShipping = true
    const answer = await confirmOrderShipped(
      this.$route.params.id,
      this.sendShippingNotification,
      this.trackingCodeEnabled ? this.trackingCode : null
    )
    this.loadingConfirmShipping = false
    if (answer.data.successful) {
      this.getSummary()
    }
  }

  async comment() {
    //save to db
    const answer = await postOrderComment(this.$route.params.id, this.commentInput)
    if (answer.data.successful) {
      const answer = await getOrderSummary(this.$route.params.id)
      if (answer.data.successful) {
        this.createTimelineFromData(answer.data.data.timeline)
        this.commentInput = null
      }
    }
  }
  get shippingCost() {
    let total = this.total
    for (const iterator of this.productTableItems) {
      total -= iterator.price * iterator.quantity
    }
    return total
  }
  private noEntriesMessage = 'Daten konnten nicht geladen werden.'
  productTableItems = []
  tableDataLoading = true
  productDialog = false
  openProduct = null
  openProductNewestRev = null
  loadingSnapshotData = false

  showShippingForm = false

  get RevDiff() {
    if (this.openProductNewestRev != null && this.openProduct != null) {
      return this.openProductNewestRev - this.openProduct.revision
    } else {
      return null
    }
  }

  getStatusIcon(value: number) {
    return value >= 3 && value <= 6 ? 'mdi-cash-check' : value > 7 ? 'mdi-cash-refund' : 'mdi-cash-clock'
  }
  async ModalProductSnapshot(row: any) {
    // TODO: open modal with snapshot data (id, rev)
    this.loadingSnapshotData = true
    this.productDialog = true
    const snapshot = await getProductSnapshot(row.product_id, row.product_rev)
    if (snapshot.data) {
      this.openProduct = snapshot.data.product
      this.openProductNewestRev = snapshot.data.currentRev
      console.log(snapshot.data)
    }

    this.loadingSnapshotData = false
  }
  private productTableHeaders = [
    {
      sortable: false,
      text: 'Bild',
      value: 'image'
    },
    {
      sortable: true,
      text: 'Name',
      value: 'name'
    },
    {
      sortable: true,
      text: 'Preis',
      value: 'price'
    },
    {
      sortable: true,
      text: 'Anzahl',
      value: 'quantity'
    }
  ]
  get MailLink() {
    return 'mailto:' + this.customerMail
  }

  address = {
    name: null,
    company: null,
    address1: null,
    address2: null,
    city: null,
    postcode: null,
    country: null,
    method: null,
    code: null
  }
  get Address() {
    let retStr = ''
    if (this.address.company != null) {
      retStr += this.address.company + '<br />'
    }
    if (this.address.address1 != null) {
      retStr += this.address.address1 + '<br />'
    }
    if (this.address.address2 != null) {
      retStr += this.address.address2 + '<br />'
    }
    if (this.address.postcode != null && this.address.city != null) {
      retStr += this.address.postcode + ' ' + this.address.city + '<br />'
    } else {
      if (this.address.city != null) {
        retStr += this.address.city + '<br />'
      }
      if (this.address.postcode != null) {
        retStr += this.address.postcode + '<br />'
      }
    }

    if (this.address.country != null) {
      retStr += this.address.country + '<br />'
    }
    if (this.address.method != null) {
      retStr += this.address.method + '<br />'
    }
    if (this.address.code != null) {
      retStr += this.address.code + '<br />'
    }

    return retStr
  }
  private statusStates = [
    { name: 'Bestellung angefangen', color: 'white', value: 1 },
    { name: 'Warte auf Zahlungseingang', color: 'white', value: 2 },
    { name: 'Bezahlung erhalten', color: 'green', value: 3 },
    { name: 'In Bearbeitung', color: 'green', value: 4 },
    { name: 'Bezahlung erhalten, Versendet', color: 'green', value: 5 },
    { name: 'Abgeschlossen', color: 'green', value: 6 },
    { name: 'Erstattung beantragt', color: 'red', value: 8 },
    { name: 'Erstattet', color: 'red', value: 9 },
    { name: 'Erstattung abgelehnt', color: 'red', value: 10 },
    { name: 'Rückbuchung', color: 'red', value: 11 }
  ]
  StatusState(input: number) {
    const c = this.statusStates.find(state => {
      if (state.value == input) return state
    })
    if (c != undefined) return c
    else return { name: 'error', color: 'purple', value: '-1' }
  }
  created() {
    this.getSummary()
  }

  total = null

  parseTime(time) {
    const dayStart = Luxon.DateTime.now().startOf('day')
    const lux = Luxon.DateTime.fromJSDate(new Date(time))
    let str
    if (dayStart.toISOWeekDate() == lux.toISOWeekDate()) {
      // only display time
      str = lux.hour + ':' + (lux.minute < 10 ? '0' + lux.minute : lux.minute)
    } else {
      // display date time
      str =
        (lux.day < 10 ? '0' + lux.day : lux.day) +
        '.' +
        (lux.month < 10 ? '0' + lux.month : lux.month) +
        '.' +
        lux.year +
        ' ' +
        (lux.hour < 10 ? '0' + lux.hour : lux.hour) +
        ':' +
        (lux.minute < 10 ? '0' + lux.minute : lux.minute)
    }
    return str
  }
  createTimelineFromData(history: any[]) {
    this.timeline = history
  }
  get timelineOld() {
    const dayStart = Luxon.DateTime.now().startOf('day')
    const oldTimeline = this.timeline.filter(item => {
      return Luxon.DateTime.fromJSDate(new Date(item.time)) < dayStart
    })

    return oldTimeline
  }
  get timelineNew() {
    const dayStart = Luxon.DateTime.now().startOf('day')
    const newTimeline = this.timeline.filter(item => {
      return Luxon.DateTime.fromJSDate(new Date(item.time)) >= dayStart
    })

    return newTimeline
  }
  async getSummary() {
    this.loadingConfirmShipping = false
    if (this.$route.params.id != undefined) {
      const answer = await getOrderSummary(this.$route.params.id)
      if (answer.data.successful) {
        const order = answer.data.data.order
        const products = answer.data.data.products
        this.createTimelineFromData(answer.data.data.timeline)

        this.shipmentInfo = answer.data.data.shipmentInfo
        this.status = this.StatusState(answer.data.data.order.order_status_id)
        this.customerName = order.firstname + ' ' + order.lastname
        this.customerMail = order.email
        this.invoiceNr = order.invoice_no
        this.address = {
          name: order.shipping_firstname + ' ' + order.shipping_lastname,
          company: order.shipping_company,
          address1: order.shipping_address_1,
          address2: order.shipping_address_2,
          city: order.shipping_city,
          postcode: order.shipping_postcode,
          country: order.shipping_country,
          method: order.shipping_method,
          code: order.shipping_code
        }
        this.total = order.total
        this.productTableItems = []
        for (const product of products) {
          const item = product
          this.productTableItems.push(item)
        }
        this.tableDataLoading = false
      }

      //
    }
  }
}
